module.exports = __webpack_public_path__ + "static/media/logout.e251addd.png";